import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  DeleteDockOperationTypeActions as Actions,
  DeleteDockOperationTypeRequestAction as RequestAction,
} from 'store/ducks/dockOperationTypes';

export function* deleteDockOperationTypeRequest(action: any) {
  const { id, onSuccess, onFailure }: RequestAction = action;
  try {
    yield call(api.delete, `dock-operation-types/${id}`);
    onSuccess && onSuccess();
    notify('success', 'Tipo de operação desvinculado com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
